module.exports = __webpack_public_path__ + "static/1-d3dd5d060144974745058129e9299c22.png";